// This file should only be imported by the action creators and reducers in this directory.
// It should not be imported by any other file nor should this file import any other file.

// TODO DPDNEW-283: Unify location of redux action keys

export const START_PROGRAMMATIC_MOVE = 'threeviewer/camera/START_PROGRAMMATIC_MOVE'
export const END_PROGRAMMATIC_MOVE = 'threeviewer/camera/END_PROGRAMMATIC_MOVE'
export const CLEAR_DIRTY = 'dirty/CLEAR'
export const SET_DIRTY = 'dirty/SET'
export const SCENE_SET_PENDING_EXTERNAL_UPDATE = 'scenes/SET_PENDING_EXTERNAL_UPDATE'
export const SCENE_SET_PENDING_EXTERNAL_RENAME = 'scenes/SET_PENDING_EXTERNAL_RENAME'
export const SCENE_SET_PENDING_EXTERNAL_DELETE = 'scenes/SCENE_SET_PENDING_EXTERNAL_DELETE'
export const SCENE_SET_SHOW_EXTERNAL_RENAME_NOTIFICATION = 'scenes/SET_SHOW_EXTERNAL_RENAME_NOTIFICATION'
export const UNDO = 'undoRedo/UNDO'
export const REDO = 'undoRedo/REDO'
export const ADD_COMMAND = 'undoRedo/ADD_COMMAND'
